module.exports = __webpack_public_path__ + "static/img/8.ff6a0a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/eng/8.png
// module id = /UY6
// module chunks = 0